import baseService from '@/utils/http/axios'
import { clearUserInfo } from '@/utils/util'
import ls from '@/utils/Storage';
import { resetRouter } from '@/router'

const user = {
    state: {
        token: '',
        name: '',
        welcome: '',
        avatar: '',
        roles: [],
        userInfo: {},
        filings_info: {},
        image_domain: '',
        image_domain_a: '',
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_IMAGE_DOMAIN: (state, image_domain) => {
            // state.image_domain = image_domain //2025-11-11刻章老是得不到这个值，暂时写死，如果后续再出现，就不是这里的问题
            state.image_domain = 'https://hncs.cskaiyela.com/storage/'
            state.image_domain_a = image_domain.replace('https://hncs.cskaiyela.com', '/hncskaiyela')
        },
        SET_NAME: (state, { name, welcome }) => {
            state.name = name
            state.welcome = welcome
        },
        SET_AVATAR: (state, avatar) => {
            state.avatar = avatar
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles
        },
        SET_USER_INFO: (state, info) => {
            state.userInfo = info
        },
        SET_FILINGS_INFO: (state, info) => {
            state.filings_info = info
        }
    },

    actions: {
        // 登录
        Login({ commit }, userInfo) {
            return new Promise((resolve, reject) => {
                let requeryParam = {
                    url: '/admin/v1/login',
                    method: 'post',
                    data: userInfo,
                }
                baseService(requeryParam).then((res: any) => {
                    commit('SET_TOKEN', `${res.data.original.token_type} ${res.data.original.access_token}`)
                    ls.set('login_success_flag', '') //清除切换标记
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 获取用户信息
        GetInfo({ commit }) {
            // 请求后端获取用户信息 /api/user/info
            let requeryParam = {
                url: '/admin/v1/userInfo',
                method: 'get',
            }
            baseService(requeryParam).then((res: any) => {
                ls.set('USER_INFO', res.data.userinfo);
                ls.set('FILINGS_INFO', res.data.filings_info);
                ls.set('IMAGE_DOMAIN', res.data.config.image_domain);
                commit('SET_USER_INFO', res.data.userinfo)
                commit('SET_FILINGS_INFO', res.data.filings_info)
                commit('SET_IMAGE_DOMAIN', res.data.config.image_domain)
            }).catch(error => {
            })
        },

        // 登出
        Logout({ commit, state }, router) {
            return new Promise((resolve) => {
                let requeryParam = {
                    url: '/admin/v1/logout',
                    method: 'delete'
                }
                baseService(requeryParam).then((res: any) => {
                    clearUserInfo()
                    resetRouter(router)
                    resolve(res)
                }).catch((err) => {
                    console.log('logout fail:', err)
                })
            })
        },

        // 切换账号
        SwitchUser({ commit }, seller) {
            return new Promise((resolve, reject) => {
                let requeryParam = {
                    url: '/admin/v1/switchUser',
                    method: 'post',
                    data: { seller: seller },
                }
                baseService(requeryParam).then((res: any) => {
                    clearUserInfo()
                    commit('SET_TOKEN', `${res.data.original.token_type} ${res.data.original.access_token}`)
                    ls.set('login_success_flag', res.data.original.login_success_flag)
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        //微信扫码登录
        WxScanUser({ commit }, param) {
            return new Promise((resolve, reject) => {
                let requeryParam = {
                    url: '/admin/v1/loginwx',
                    method: 'post',
                    data: { id: param.id, openid: param.openid, step: 5 },
                }
                baseService(requeryParam).then((res: any) => {
                    clearUserInfo()
                    commit('SET_TOKEN', `${res.data.original.token_type} ${res.data.original.access_token}`)
                    ls.set('login_success_flag', '') //清除切换标记
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        //公众号扫码登录
        GzhScanUser({ commit }, param) {
            return new Promise((resolve, reject) => {
                let requeryParam = {
                    url: '/admin/v1/logingzh',
                    method: 'post',
                    data: { id: param.id, openid: param.openid, step: 5 },
                }
                baseService(requeryParam).then((res: any) => {
                    clearUserInfo()
                    commit('SET_TOKEN', `${res.data.original.token_type} ${res.data.original.access_token}`)
                    ls.set('login_success_flag', '') //清除切换标记
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        MobileLogin({ commit }, param) {
            return new Promise((resolve, reject) => {
                let requeryParam = {
                    url: '/admin/v1/mobilewx',
                    method: 'post',
                    data: { mobile: param.mobile, captcha: param.captcha, step: 2 },
                }
                baseService(requeryParam).then((res: any) => {
                    clearUserInfo()
                    commit('SET_TOKEN', `${res.data.original.token_type} ${res.data.original.access_token}`)
                    ls.set('login_success_flag', '') //清除切换标记
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        //刷新 token
        RefreshToken({ commit }, token) {
            return new Promise((resolve, reject) => {
                commit('SET_TOKEN', token)
                resolve('')
            })
        }

    }
}

export default user
